import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export function ProtectedRoute({ children, adminOnly = false, managerOnly = false, staffOnly = false }) {
    const { user, loading } = useAuth();
    const location = useLocation();

    if (loading) {
        return (
            <div className="flex items-center justify-center min-h-screen bg-background">
                <div className="text-[#00FF66] font-display text-xl tracking-widest uppercase animate-pulse">Loading...</div>
            </div>
        );
    }

    if (!user) {
        return <Navigate to="/login" state={{ from: location }} replace />;
    }

    const role = user.role;
    if (adminOnly && !["super_admin", "admin"].includes(role)) {
        // A manager hitting an /admin route → bounce to /manager (NOT the player home).
        if (role === "manager") return <Navigate to="/manager" replace />;
        return <Navigate to="/" replace />;
    }
    if (managerOnly && role !== "manager") {
        // Admins also pass managerOnly (so they can preview manager pages) — but redirect dedicated managers in
        if (!["super_admin", "admin"].includes(role)) return <Navigate to="/" replace />;
    }
    if (staffOnly && !["super_admin", "admin", "manager"].includes(role)) {
        return <Navigate to="/" replace />;
    }

    // Iter 31 — Strict manager fence: a logged-in manager must NEVER appear on
    // a player route. The only routes available to managers are `/manager/*`
    // and shared static/info pages. Any other path → redirect to /manager.
    if (role === "manager") {
        const p = location.pathname || "/";
        const allowedExact = ["/about", "/terms", "/privacy", "/cancellation-policy", "/contact"];
        const allowedPrefix = ["/manager"];
        const isAllowed = allowedExact.includes(p) || allowedPrefix.some((x) => p === x || p.startsWith(x + "/"));
        if (!isAllowed) {
            return <Navigate to="/manager" replace />;
        }
    }

    return children;
}
